import React from 'react'
import RatingStars from 'src/widgets/RatingStars/RatingStars'

export default function OutletLabTemplate({
  viewOnly = false,
  ratingData,
  onChange,
  submittedRating,
}) {
  const getTotalRating = () => {
    const {
      job_understanding,
      devotion_to_duty,
      job_skills,
      successful_leads,
      attendance,
      dependability,
      attitude,
      maintenance_of_outlets,
      display_of_products,
      services,
      cooperation_with_colleagues,
      marketing_skills,
    } = ratingData

    let total =
      parseInt(job_understanding) +
      parseInt(devotion_to_duty) +
      parseInt(job_skills) +
      parseInt(successful_leads) +
      parseInt(attendance) +
      parseInt(dependability) +
      parseInt(attitude) +
      parseInt(maintenance_of_outlets) +
      parseInt(display_of_products) +
      parseInt(services) +
      parseInt(cooperation_with_colleagues) +
      parseInt(marketing_skills)
    return total
  }

  const getSubmittedRating = () => {
    const {
      job_understanding,
      devotion_to_duty,
      job_skills,
      successful_leads,
      attendance,
      dependability,
      attitude,
      maintenance_of_outlets,
      display_of_products,
      services,
      cooperation_with_colleagues,
      marketing_skills,
    } = submittedRating

    let total =
      parseInt(job_understanding) +
      parseInt(devotion_to_duty) +
      parseInt(job_skills) +
      parseInt(successful_leads) +
      parseInt(attendance) +
      parseInt(dependability) +
      parseInt(attitude) +
      parseInt(maintenance_of_outlets) +
      parseInt(display_of_products) +
      parseInt(services) +
      parseInt(cooperation_with_colleagues) +
      parseInt(marketing_skills)
    return total
  }

  return (
    <>
      <div style={{ padding: '10px' }}>
        <table
          width="100%"
          className="table table-striped"
          style={{
            marginTop: '16px',
            borderCollapse: 'collapse',
            fontFamily: 'Arial, sans-serif',
          }}
        >
          <tbody>
            <tr>
              <th style={{ width: '70px' }}>Misc. Aspects</th>
              <th style={{ width: '24px' }}>Submitted Rating</th>
              <th style={{ width: '24px' }}>RATING FACTORS</th>
              <th style={{ width: '6px' }}>RATING</th>
            </tr>
            <tr>
              <td>
                <strong>Job Understanding</strong>
              </td>
              <td>{submittedRating.job_understanding}/10</td>
              <td>
                <RatingStars
                  count={10}
                  value={ratingData.job_understanding}
                  onChange={(value) => onChange('job_understanding', value)}
                  viewOnly={viewOnly}
                />
              </td>
              <td>
                <b style={{ color: 'blue' }} readOnly={viewOnly}>
                  {ratingData !== null ? `${ratingData.job_understanding}/10` : ''}
                </b>
              </td>
            </tr>
            <tr>
              <td>
                <strong>Devotion to Duty</strong>
              </td>
              <td>{submittedRating.devotion_to_duty}/10</td>
              <td>
                <RatingStars
                  count={10}
                  value={ratingData.devotion_to_duty}
                  onChange={(value) => onChange('devotion_to_duty', value)}
                  viewOnly={viewOnly}
                />
              </td>
              <td>
                <b style={{ color: 'blue' }} readOnly={viewOnly}>
                  {ratingData !== null ? `${ratingData.devotion_to_duty}/10` : ''}
                </b>
              </td>
            </tr>
            <tr>
              <td>
                <strong>Job Skills</strong>
              </td>
              <td>{submittedRating.job_skills}/10</td>
              <td>
                <RatingStars
                  count={10}
                  value={ratingData.job_skills}
                  onChange={(value) => onChange('job_skills', value)}
                  viewOnly={viewOnly}
                />
              </td>
              <td>
                <b style={{ color: 'blue' }} readOnly={viewOnly}>
                  {ratingData !== null ? `${ratingData.job_skills}/10` : ''}
                </b>
              </td>
            </tr>
            <tr>
              <td>
                <strong>Successful Leads / Orders</strong>
              </td>
              <td>{submittedRating.successful_leads}/10</td>
              <td>
                <RatingStars
                  count={10}
                  value={ratingData.successful_leads}
                  onChange={(value) => onChange('successful_leads', value)}
                  viewOnly={viewOnly}
                />
              </td>
              <td>
                <b style={{ color: 'blue' }} readOnly={viewOnly}>
                  {ratingData !== null ? `${ratingData.successful_leads}/10` : ''}
                </b>
              </td>
            </tr>
            <tr>
              <td>
                <strong>Attendance</strong>
              </td>
              <td>{submittedRating.attendance}/10</td>
              <td>
                <RatingStars
                  count={10}
                  value={ratingData.attendance}
                  onChange={(value) => onChange('attendance', value)}
                  viewOnly={viewOnly}
                />
              </td>
              <td>
                <b style={{ color: 'blue' }} readOnly={viewOnly}>
                  {ratingData !== null ? `${ratingData.attendance}/10` : ''}
                </b>
              </td>
            </tr>
            <tr>
              <td>
                <strong>Customer Services / Dependability</strong>
              </td>
              <td>{submittedRating.dependability}/10</td>
              <td>
                <RatingStars
                  count={10}
                  value={ratingData.dependability}
                  onChange={(value) => onChange('dependability', value)}
                  viewOnly={viewOnly}
                />
              </td>
              <td>
                <b style={{ color: 'blue' }} readOnly={viewOnly}>
                  {ratingData !== null ? `${ratingData.dependability}/10` : ''}
                </b>
              </td>
            </tr>
            <tr>
              <td>
                <strong>Attitude</strong>
              </td>
              <td>{submittedRating.attitude}/10</td>
              <td>
                <RatingStars
                  count={10}
                  value={ratingData.attitude}
                  onChange={(value) => onChange('attitude', value)}
                  viewOnly={viewOnly}
                />
              </td>
              <td>
                <b style={{ color: 'blue' }} readOnly={viewOnly}>
                  {ratingData !== null ? `${ratingData.attitude}/10` : ''}
                </b>
              </td>
            </tr>
            <tr>
              <td>
                <strong>Maintenance of Outlets</strong>
              </td>
              <td>{submittedRating.maintenance_of_outlets}/10</td>
              <td>
                <RatingStars
                  count={10}
                  value={ratingData.maintenance_of_outlets}
                  onChange={(value) => onChange('maintenance_of_outlets', value)}
                  viewOnly={viewOnly}
                />
              </td>
              <td>
                <b style={{ color: 'blue' }} readOnly={viewOnly}>
                  {ratingData !== null ? `${ratingData.maintenance_of_outlets}/10` : ''}
                </b>
              </td>
            </tr>
            <tr>
              <td>
                <strong>Display of Products</strong>
              </td>
              <td>{submittedRating.display_of_products}/10</td>
              <td>
                <RatingStars
                  count={10}
                  value={ratingData.display_of_products}
                  onChange={(value) => onChange('display_of_products', value)}
                  viewOnly={viewOnly}
                />
              </td>
              <td>
                <b style={{ color: 'blue' }} readOnly={viewOnly}>
                  {ratingData !== null ? `${ratingData.display_of_products}/10` : ''}
                </b>
              </td>
            </tr>
            <tr>
              <td>
                <strong>Services</strong>
              </td>
              <td>{submittedRating.services}/10</td>
              <td>
                <RatingStars
                  count={10}
                  value={ratingData.services}
                  onChange={(value) => onChange('services', value)}
                  viewOnly={viewOnly}
                />
              </td>
              <td>
                <b style={{ color: 'blue' }} readOnly={viewOnly}>
                  {ratingData !== null ? `${ratingData.services}/10` : ''}
                </b>
              </td>
            </tr>
            <tr>
              <td>
                <strong>Cooperation with colleagues & customers</strong>
              </td>
              <td>{submittedRating.cooperation_with_colleagues}/10</td>
              <td>
                <RatingStars
                  count={10}
                  value={ratingData.cooperation_with_colleagues}
                  onChange={(value) => onChange('cooperation_with_colleagues', value)}
                  viewOnly={viewOnly}
                />
              </td>
              <td>
                <b style={{ color: 'blue' }} readOnly={viewOnly}>
                  {ratingData !== null ? `${ratingData.cooperation_with_colleagues}/10` : ''}
                </b>
              </td>
            </tr>
            <tr>
              <td>
                <strong>Sales & Marketing Skills</strong>
              </td>
              <td>{submittedRating.marketing_skills}/10</td>
              <td>
                <RatingStars
                  count={10}
                  value={ratingData.marketing_skills}
                  onChange={(value) => onChange('marketing_skills', value)}
                  viewOnly={viewOnly}
                />
              </td>
              <td>
                <b style={{ color: 'blue' }} readOnly={viewOnly}>
                  {ratingData !== null ? `${ratingData.marketing_skills}/10` : ''}
                </b>
              </td>
            </tr>
            <tr>
              <td>
                <b readOnly={viewOnly}>Overall Performance:</b>
              </td>
              <td style={{ color: 'green', fontWeight: 'bold' }}> {getSubmittedRating()} / 120</td>
              <td></td>
              <td style={{ color: 'green', fontWeight: 'bold' }}> {getTotalRating()} / 120</td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  )
}
